import React, { Component } from 'react'
import {
    Route,
    Switch,
} from 'react-router-dom'
const SuperAdminEvents = React.lazy(() => import('../super-admin/events'))
const SuperAdminNews = React.lazy(() => import('../super-admin/news'))
const SuperAdminGroups = React.lazy(() => import('../super-admin/groups'))
const SuperAdminNewsForm = React.lazy(() => import('../super-admin/form/news'))
const SuperAdminNewsDetail = React.lazy(() => import('../super-admin/news/full'))
const SuperAdmin = React.lazy(() => import('../super-admin/container'))
const SuperAdminStats = React.lazy(() => import('../super-admin/stats'))
const SuperAdminSync = React.lazy(() => import('../super-admin/sync'))
const SuperAdminGlobalChat = React.lazy(() => import('../super-admin/global-chat'))
import SuperAdminRoute from './shared/super-admin-route'
import {
    forFeature,
    withRouter,
} from '../validator'
import NotFoundRoute from './shared/not-found-route'
import SuperAdminSport from '../super-admin/sport/super-admin-sport'

@forFeature('SPORTNECT_ROUTES')
@withRouter()
export default class SuperAdminRoutes extends Component {
    render = () => (
        <React.Suspense fallback={<span />}>
            <Switch>
                <Route exact path={'/super-admin'} render={() => (
                    <SuperAdmin whitelistedFilterRoute>
                        <SuperAdminEvents {...this.props} />
                    </SuperAdmin>
                )} />

                <Route exact path={'/super-admin/news'} render={() => (
                    <SuperAdmin whitelistedFilterRoute>
                        <SuperAdminNews {...this.props} />
                    </SuperAdmin>
                )} />

                <Route exact path={'/super-admin/news/add'} render={() => (
                    <SuperAdmin>
                        <SuperAdminNewsForm {...this.props} />
                    </SuperAdmin>
                )} withMenu={false} />

                <Route exact path={'/super-admin/news/:actualitySlug'} render={() => (
                    <SuperAdmin>
                        <SuperAdminNewsDetail {...this.props} />
                    </SuperAdmin>
                )} withMenu={false} />

                <Route exact path={'/super-admin/news/:actualitySlug/edit'} render={() => (
                    <SuperAdmin>
                        <SuperAdminNewsForm {...this.props} />
                    </SuperAdmin>
                )} withMenu={false} />

                <Route exact path={'/super-admin/clubs'} render={() => (
                    <SuperAdmin whitelistedFilterRoute>
                        <SuperAdminGroups {...this.props} />
                    </SuperAdmin>
                )} />

                <Route exact path={'/super-admin/stats'} render={() => (
                    <SuperAdmin>
                        <SuperAdminStats {...this.props} />
                    </SuperAdmin>
                )} />

                <SuperAdminRoute exact path={'/super-admin/sync'} render={() => (
                    <SuperAdmin>
                        <SuperAdminSync {...this.props} />
                    </SuperAdmin>
                )} />

                <SuperAdminRoute exact path={'/super-admin/global-chat'} render={() => (
                    <SuperAdmin>
                        <SuperAdminGlobalChat {...this.props} />
                    </SuperAdmin>
                )} />

                <SuperAdminRoute exact path={'/super-admin/sport'} render={() => (
                    <SuperAdmin>
                        <SuperAdminSport {...this.props} />
                    </SuperAdmin>
                )} />

                <NotFoundRoute routesType="superAdminRoutes" />
            </Switch>
        </React.Suspense>
    )
}

